import http from '@/http'

const PATH = (id) => `/customers/${id}/invoices`

export default {
    /**
     * @param {{customerId: number, params: {}}} data
     * @returns {Promise<void>}
     */
    async listInvoices ({customerId, params}) {
        try {
            const response = await http.get(PATH(customerId), {params})
            return response.data
        } catch (e) {
            return Promise.reject(e)
        }
    },
    /**
     * @param {{customerId: number, invoiceId: number}} data
     * @returns {Promise<void>}
     */
    async showInvoice ({customerId, invoiceId}) {
        try {
            const response = await http.get(`${PATH(customerId)}/${invoiceId}`)
            return response.data
        } catch (e) {
            return Promise.reject(e)
        }
    }
}
